import React from "react";
// import { Arrow } from "./Arrow";
// import { BaseClose } from "./BaseClose";
import styles from "./modal-header.module.scss";
import { ArrowIconComponent } from "../../info-tables/arrow-icon.component";
import CrossIcon from "../../../../icons/cross.icon";

export const ModalHeader = ({ metric, closeModal = () => {} }) => {
  const onClose = () => {
    closeModal();
  }
  if (!metric) {
    return null;
  }

  const isPositive = metric.changePercent && !metric.changePercent.startsWith('-');
  const displayPercentage = metric.percentage || metric.unit || '';

  return (
    <div className={styles.detailModalHeader}>
      <div className={styles.detailModalHeaderContent}>
        <h1 className={styles.detailModalTitle}>
          {metric.value} {metric.label}
        </h1>

        {metric.changePercent && (
          <div
            className={styles.detailModalChangeIndicator}
            role="status"
            aria-label={`${metric.changePercent} ${isPositive ? 'increase' : 'decrease'}`}
          >
            <ArrowIconComponent isPositive={isPositive} />
            <span className={`${styles.detailModalChangeText} ${isPositive ? styles.detailModalChangeTextPositive : styles.detailModalChangeTextNegative}`}>
              {metric.changePercent}
            </span>
          </div>
        )}

        {displayPercentage && (
          <div className={styles.detailModalPercentageContainer}>
            <span className={styles.detailModalPercentageText}>
              {displayPercentage}
            </span>
          </div>
        )}
      </div>

      <CrossIcon 
        className={styles.detailModalCloseButton} 
        onClick={onClose}
        width="9px"
        height="9px"
      />
    </div>
  );
};